(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-page-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Fallback para browsers viejos que no soportan name="" en <details>
    // (Chrome 120+, Safari 17.2+, Firefox 123+ ya lo hacen nativo)
    var supportsExclusive = 'name' in document.createElement('details');
    if (supportsExclusive) return;

    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.matches || !d.matches('.mkpt__item')) return;
      if (!d.open) return;
      var name = d.getAttribute('name');
      if (!name) return;
      var siblings = document.querySelectorAll('details.mkpt__item[name="' + name + '"]');
      siblings.forEach(function (s) { if (s !== d && s.open) s.open = false; });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
